import moment from 'moment';

//
// Shadowlands Dates
//
export const SL_LAUNCH_DATE = moment.utc('2020-11-23T23:00:00Z');

//
// Dragonflight Dates
//
export const DF_LAUNCH_DATE = moment.utc('2022-11-28T23:00:00Z');

export const DF_PREPATCH_LAUNCH_DATES = {
  us: moment.utc('2022-10-25T15:00:00'),
  eu: moment.utc('2022-10-26T07:00:00'),
  tw: moment.utc('2022-10-26T23:00:00'),
  kr: moment.utc('2022-10-26T23:00:00'),
  cn: moment.utc('2022-10-26T23:00:00')
};

export const DF_SEASON1_DATES = {
  us: moment.utc('2022-12-13T15:00:00'),
  eu: moment.utc('2022-12-14T04:00:00'),
  tw: moment.utc('2022-12-14T23:00:00'),
  kr: moment.utc('2022-12-14T23:00:00'),
  cn: moment.utc('2022-12-14T23:00:00')
};

export const DF_SEASON2_DATES = {
  us: moment.utc('2023-05-09T15:00:00'),
  eu: moment.utc('2023-05-10T04:00:00'),
  tw: moment.utc('2023-05-10T23:00:00'),
  kr: moment.utc('2023-05-10T23:00:00'),
  cn: moment.utc('2023-05-10T23:00:00')
};

export const DF_SEASON3_DATES = {
  us: moment.utc('2023-11-14T15:00:00'),
  eu: moment.utc('2023-11-15T04:00:00'),
  tw: moment.utc('2023-11-15T23:00:00'),
  kr: moment.utc('2023-11-15T23:00:00'),
  cn: moment.utc('2023-11-15T23:00:00')
};

export const DF_SEASON4_DATES = {
  us: moment.utc('2024-04-23T15:00:00'),
  eu: moment.utc('2024-04-24T04:00:00'),
  tw: moment.utc('2024-04-24T23:00:00'),
  kr: moment.utc('2024-04-24T23:00:00'),
  cn: moment.utc('2024-04-24T23:00:00')
};

// Draconic Hero qualification closes before the pre-expansion maintenance.
// Regional schedule: https://worldofwarcraft.blizzard.com/en-us/news/24117143
export const DF_SEASON4_CUTOFFS_DATES = {
  us: moment.utc('2024-07-23T05:00:00'),
  eu: moment.utc('2024-07-23T20:00:00'),
  tw: moment.utc('2024-07-24T14:00:00'),
  kr: moment.utc('2024-07-24T13:00:00'),
  // Retain the existing calendar boundary; CN retail reopened after title qualification ended.
  cn: moment.utc('2024-07-24T23:00:00')
};

export const TWW_PREPATCH_LAUNCH_DATES = {
  us: moment.utc('2024-07-23T15:00:00'),
  eu: moment.utc('2024-07-24T04:00:00'),
  tw: moment.utc('2024-07-24T23:00:00'),
  kr: moment.utc('2024-07-24T23:00:00'),
  cn: moment.utc('2024-07-24T23:00:00')
};

// The War Within Early Access begins, Normal Dungeons open
export const TWW_PRE_ACCESS_LAUNCH_DATES = {
  us: moment.utc('2024-08-22T22:00:00'),
  eu: moment.utc('2024-08-22T22:00:00'),
  tw: moment.utc('2024-08-22T22:00:00'),
  kr: moment.utc('2024-08-22T22:00:00'),
  cn: moment.utc('2024-08-22T22:00:00')
};

// Global release - with Heroic Dungeons, and DF4 PVE retired
export const TWW_GLOBAL_LAUNCH_DATES = {
  us: moment.utc('2024-08-26T22:00:00'),
  eu: moment.utc('2024-08-26T22:00:00'),
  tw: moment.utc('2024-08-26T22:00:00'),
  kr: moment.utc('2024-08-26T22:00:00'),
  cn: moment.utc('2024-08-26T22:00:00')
};

// Start Raid Heroic Week, and M0 Dungeon, Heroic and M0 Seasonal Dungeon, PvP Season 1
export const TWW_SEASON1_DATES = {
  us: moment.utc('2024-09-10T15:00:00'),
  eu: moment.utc('2024-09-11T04:00:00'),
  tw: moment.utc('2024-09-11T23:00:00'),
  kr: moment.utc('2024-09-11T23:00:00'),
  cn: moment.utc('2024-09-11T23:00:00')
};

export const TWW_SEASON1_MPLUS_DATES = {
  us: moment.utc('2024-09-17T15:00:00'),
  eu: moment.utc('2024-09-18T04:00:00'),
  tw: moment.utc('2024-09-18T23:00:00'),
  kr: moment.utc('2024-09-18T23:00:00'),
  cn: moment.utc('2024-09-18T23:00:00')
};

// Start BRD (20th Anniversary)
export const TWW_BRD_START_DATES = {
  us: moment.utc('2024-10-22T15:00:00'),
  eu: moment.utc('2024-10-23T04:00:00'),
  tw: moment.utc('2024-10-23T23:00:00'),
  kr: moment.utc('2024-10-23T23:00:00'),
  cn: moment.utc('2024-10-23T23:00:00')
};
// Might need update, I've set it on reset day, but announcement says January 6, 2025 so weird
export const TWW_BRD_END_DATES = {
  us: moment.utc('2025-01-07T15:00:00'),
  eu: moment.utc('2025-01-08T04:00:00'),
  tw: moment.utc('2025-01-08T23:00:00'),
  kr: moment.utc('2025-01-08T23:00:00'),
  cn: moment.utc('2025-01-08T23:00:00')
};

export const TWW_SEASON2_DATES = {
  us: moment.utc('2025-03-04T15:00:00'),
  eu: moment.utc('2025-03-05T04:00:00'),
  tw: moment.utc('2025-03-05T23:00:00'),
  kr: moment.utc('2025-03-05T23:00:00'),
  cn: moment.utc('2025-03-05T23:00:00')
};

export const TWW_SEASON3_DATES = {
  us: moment.utc('2025-08-12T15:00:00'),
  eu: moment.utc('2025-08-13T04:00:00'),
  tw: moment.utc('2025-08-13T23:00:00'),
  kr: moment.utc('2025-08-13T23:00:00'),
  cn: moment.utc('2025-08-13T23:00:00')
};

export const TWW_SEASON3_LEGION_REMIX_DATES = {
  us: moment.utc('2025-10-07T15:00:00'),
  eu: moment.utc('2025-10-08T04:00:00'),
  tw: moment.utc('2025-10-08T23:00:00'),
  kr: moment.utc('2025-10-08T23:00:00'),
  cn: moment.utc('2025-10-08T23:00:00')
};

export const TWW_SEASON3_CUTOFFS_DATES = {
  us: moment.utc('2026-01-20T06:00:00'),
  eu: moment.utc('2026-01-20T21:00:00'),
  tw: moment.utc('2026-01-21T14:00:00'),
  kr: moment.utc('2026-01-21T14:00:00'),
  cn: moment.utc('2026-01-21T14:00:00')
};

// Global release - with Heroic Dungeons, and TWW3 PVE retired
export const MIDNIGHT_GLOBAL_LAUNCH_DATES = {
  us: moment.utc('2026-03-02T22:00:00'),
  eu: moment.utc('2026-03-02T22:00:00'),
  tw: moment.utc('2026-03-02T22:00:00'),
  kr: moment.utc('2026-03-02T22:00:00'),
  cn: moment.utc('2026-03-02T22:00:00')
};

// Start Raid Heroic Week, and M0 Dungeon, Heroic and M0 Seasonal Dungeon, PvP Season 1
export const MIDNIGHT_SEASON1_DATES = {
  us: moment.utc('2026-03-17T15:00:00'),
  eu: moment.utc('2026-03-18T04:00:00'),
  tw: moment.utc('2026-03-18T23:00:00'),
  kr: moment.utc('2026-03-18T23:00:00'),
  cn: moment.utc('2026-03-18T23:00:00')
};

// Mythic raid opens one week after heroic
export const MIDNIGHT_SEASON1_MYTHIC_DATES = {
  us: moment.utc('2026-03-24T15:00:00'),
  eu: moment.utc('2026-03-25T04:00:00'),
  tw: moment.utc('2026-03-25T23:00:00'),
  kr: moment.utc('2026-03-25T23:00:00'),
  cn: moment.utc('2026-03-25T23:00:00')
};

// Start M+, and Mythic raid
export const MIDNIGHT_SEASON1_MPLUS_DATES = {
  us: moment.utc('2026-03-24T15:00:00'),
  eu: moment.utc('2026-03-25T04:00:00'),
  tw: moment.utc('2026-03-25T23:00:00'),
  kr: moment.utc('2026-03-25T23:00:00'),
  cn: moment.utc('2026-03-25T23:00:00')
};

export const MIDNIGHT_MARCHONQUELDANAS_DATES = {
  us: moment.utc('2026-03-31T15:00:00'),
  eu: moment.utc('2026-04-01T04:00:00'),
  tw: moment.utc('2026-04-01T23:00:00'),
  kr: moment.utc('2026-04-01T23:00:00'),
  cn: moment.utc('2026-04-01T23:00:00')
};

export const MIDNIGHT_SPOREFALL_DATES = {
  us: moment.utc('2026-06-16T15:00:00'),
  eu: moment.utc('2026-06-17T04:00:00'),
  tw: moment.utc('2026-06-17T23:00:00'),
  kr: moment.utc('2026-06-17T23:00:00'),
  cn: moment.utc('2026-06-17T23:00:00')
};

// season-mn-1.ends, the MN1 recap timeline domain, its Commitment axis, and its gear
// cutoff all derive from this date.
export const MIDNIGHT_SEASON2_DATES = {
  us: moment.utc('2026-08-18T15:00:00'),
  eu: moment.utc('2026-08-19T04:00:00'),
  tw: moment.utc('2026-08-19T23:00:00'),
  kr: moment.utc('2026-08-19T23:00:00'),
  cn: moment.utc('2026-08-19T23:00:00')
};

// Unlike Season 1, Mythic opens with the week-1 reset alongside Normal/Heroic
// (Blizzard: "Curse of Ula'tek: The Venomous Abyss Raid Goes Live August 18")
export const MIDNIGHT_SEASON2_MYTHIC_DATES = {
  us: moment.utc('2026-08-18T15:00:00'),
  eu: moment.utc('2026-08-19T04:00:00'),
  tw: moment.utc('2026-08-19T23:00:00'),
  kr: moment.utc('2026-08-19T23:00:00'),
  cn: moment.utc('2026-08-19T23:00:00')
};
